/**
 * @generated SignedSource<<b6a6f2d3c39d179b9139337c48f83a3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BillingCycle = "MONTHLY_IN_ADVANCE" | "MONTHLY_IN_ARREARS" | "ONE_TIME" | "QUARTERLY_IN_ADVANCE" | "YEARLY_IN_ADVANCE" | "%future added value";
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type SupplierAmountEstimateSource = "HETZNER" | "%future added value";
export type SuppliersViewQuery$variables = Record<PropertyKey, never>;
export type SuppliersViewQuery$data = {
  readonly suppliers: ReadonlyArray<{
    readonly amountEstimateSource: SupplierAmountEstimateSource | null | undefined;
    readonly billingCycle: BillingCycle | null | undefined;
    readonly expenseCategory: ExpenseCategory | null | undefined;
    readonly id: string;
    readonly invoiceCount: number;
    readonly name: string;
    readonly netAmountInEuroLastTwelveMonths: number;
    readonly proposedServicePeriodCount: number;
    readonly spellings: ReadonlyArray<string>;
    readonly supplierIdentifier: string;
  }>;
};
export type SuppliersViewQuery = {
  response: SuppliersViewQuery$data;
  variables: SuppliersViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Supplier",
    "kind": "LinkedField",
    "name": "suppliers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supplierIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategory",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingCycle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountEstimateSource",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spellings",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "netAmountInEuroLastTwelveMonths",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invoiceCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "proposedServicePeriodCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuppliersViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SuppliersViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e6146e58971ba9c91073e940e28edcf5",
    "id": null,
    "metadata": {},
    "name": "SuppliersViewQuery",
    "operationKind": "query",
    "text": "query SuppliersViewQuery {\n  suppliers {\n    id\n    supplierIdentifier\n    name\n    expenseCategory\n    billingCycle\n    amountEstimateSource\n    spellings\n    netAmountInEuroLastTwelveMonths\n    invoiceCount\n    proposedServicePeriodCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0ab3cc544d21b569e8e521eb14ee862";

export default node;
